<template lang="pug">
  div(class="error container-fluid")
    div(class="error__container")
      div(class="text-center error__container__logo")
        img(:src="logoImg" class="img-fluid logo")
      div(class="text-center problem")
        img(:src="problemImg" class="img-fluid")
        p(class="problem__try text-dark mb-0") 請稍後再試
        p(class="problem__try text-dark mb-0") 網頁關閉期間，請至各區營業所出貨，或傳真至各營業所進行傳刷作業
      div(class="error__actions")
        button(class="btn btn-success w-100" type="button"  onclick="javascript:window.open('http://tocinmail.com.tw', '_blank')") 業績信箱
        PerformanceEntry(class="btn w-100 btn-search text-success" :busy="ssoBusy" :legacy="ssoShowLegacy" :version="ssoEntryVersion" @open="openHaotianSso")
        a(class="btn w-100 btn-search text-success" href="http://211.75.213.163/(S(hjjue2555sq1eh55qtqiypr3))/pv.aspx" target="_blank" rel="noopener noreferrer") 組織業績
</template>

<script>
import haotianSso from '@/utils/haotian-sso'
import PerformanceEntry from '@/components/PerformanceEntry.vue'
import logoImg from '@/assets/svg/error-logo.svg'
import problemImg from '@/assets/svg/error-problem.svg'
import { mapState } from 'vuex'

export default {
  mixins: [haotianSso],
  components: { PerformanceEntry },
  data () {
    return {
      logoImg,
      problemImg
    }
  },
  computed: {
    ...mapState({
      UserData: state => state.model.UserData
    })
  }
}
</script>

<style lang="scss" scoped>
  .error{
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px 24px;
    padding-top: max(32px, env(safe-area-inset-top));
    padding-bottom: max(32px, env(safe-area-inset-bottom));
    box-sizing: border-box;
    .error__container{
      width: 100%;
      max-width: 340px;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }
    .btn-search{
      border: 1px solid #56870F;
    }
    .error__container__logo{
      padding-bottom: 24px;
      border-bottom: 1px solid #D8D8D8;
    }
    .logo { width: 96px; }
    .problem > img { width: 104px; }
    .problem__try { line-height: 1.7; }
    .error__actions {
      display: flex;
      flex-direction: column;
      gap: 8px;
      > .btn {
        height: 44px;
        min-height: 44px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .performance-entry {
      ::v-deep > a:not(.legacy-entry) {
        width: 100%;
        min-height: 0;
        height: 100%;
        justify-content: center;
      }
      ::v-deep > button {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        min-height: 0;
      }
    }
  }
</style>
